import request from './request'

export function listOrderTask(data) {
  return request.post('/production/order-tasks/list', data)
}
export function getOrderTask(id) {
  return request.get('/production/order-tasks/' + id)
}
export function startOrderTask(data) {
  return request.post('/production/order-tasks/start', data)
}
export function finishOrderTask(data) {
  return request.post('/production/order-tasks/finish', data)
}
export function cancelOrderTask(data) {
  return request.post('/production/order-tasks/cancel', data)
}
export function selectOrderTask(orderId) {
  return request.get('/production/order-tasks/select-by-order/' + orderId)
}
